import React from "react";
import RadioGroup from "@material-ui/core/RadioGroup";
import Grid from "@material-ui/core/Grid";
import FormLabel from "@material-ui/core/FormLabel";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import {StyledRadio} from "../../../../../utils/designComponents/StyledRadio";
import Typography from "@material-ui/core/Typography";


const smallFont = {fontSize: 15};

export default function QuantitBasisSelect({quantityBasis, setQuantityBasis}) {
    return (
        <RadioGroup
            row
            aria-label="quantityBasis"
            name="quantityBasis"
            value={quantityBasis}
            onChange={(ev) => {
                setQuantityBasis(ev.target.value);
            }}
        >
            <Grid container>
                <Grid item xs={4}>
                    <FormLabel><Typography style={smallFont}>qty basis:</Typography></FormLabel>
                </Grid>
                <Grid item xs={4}>
                    <FormControlLabel value="DOLLARS" control={<StyledRadio/>}
                                      label={<Typography style={smallFont}>DOLLARS</Typography>}/>
                </Grid>
                <Grid item xs={4}>
                    <FormControlLabel value="QUANTITY" control={<StyledRadio/>}
                                      label={<Typography style={smallFont}>QUANTITY</Typography>}/>
                </Grid>
            </Grid>
        </RadioGroup>
    );
}